var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"column is-one-third"},[_c('h4',{staticClass:"title is-6"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","height":"220px"}},[_c('canvas',{ref:'bar'+i,refInFor:true})])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d9b5ddb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cultura/sections/results/ResultsBars.vue
// module id = 1908
// module chunks = 2